<div class="bg-white rounded-lg shadow-sm p-4 mb-4">
  <h2 class="text-xl font-bold mb-4">Información de entrega</h2>

  <!-- Dirección de entrega -->
  <div
    class="bg-gray-50 rounded-lg p-4 mb-3 flex items-center justify-between cursor-pointer"
    (click)="openLocationModal()"
  >
    <div class="flex items-center">
      <div class="text-amber-500 mr-3">
        <!-- Ícono de ubicación -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </div>
      <div>
        <div class="text-sm font-medium">Dirección de entrega</div>
        <div class="text-gray-700" title="{{selectedAddress?.ad_full_address}}">{{selectedAddress?.ad_name}}</div>
      </div>
    </div>
    <button class="text-gray-400">
      <!-- Ícono de flecha derecha -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>

  <!-- Tiempo estimado de entrega -->
  <div class="bg-gray-50 rounded-lg p-4 flex items-center">
    <div class="text-amber-500 mr-3">
      <!-- Ícono de reloj -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <div>
      <div class="text-sm font-medium">Tiempo estimado de entrega</div>
      <div class="text-gray-700">30-45 minutos</div>
    </div>
  </div>
</div>
